import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Alert, AlertTitle} from "@material-ui/lab";
import Button from "@material-ui/core/Button";

export default function DeleteModal({open, onClose, onConfirm}) {
    const handleClose = () => {
        onClose && onClose()
    }

    const handleConfirmation = () => {
        onConfirm && onConfirm()
        handleClose()
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Attention!</DialogTitle>
            <DialogContent>
                <Alert severity="error">
                    <AlertTitle>Est vous sure d'effectuer la surpression?</AlertTitle>
                    Cette action est irreversible!
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Non
                </Button>
                <Button variant='contained' color='secondary' onClick={handleConfirmation}>
                    Oui, Je confirme!
                </Button>
            </DialogActions>
        </Dialog>
    )
}